import { QueryType } from './queryRegistry'
import { useRoleQuery } from './registry/useRoleQuery';
import { QueryHookResult } from './useGenericQuery'
import { useAssignedProjects } from './registry/useAssignedProjects';
import { useTaskByEmployeeAndProject } from './registry/useTaskByEmployeeAndProject';

// Interface to define the structure of a query hook
interface QueryHook<T = unknown> {
  type: QueryType;
  useHook: (params?: unknown) => QueryHookResult<T>;
}

// Definition of available hooks with their adapters
const queries: QueryHook[] = [
  {
    type: 'roles',
    useHook: () => useRoleQuery()
  },
  {
    type: 'assignedProjects',
    useHook: ({ idEmployee, endDate } ) => {
      return useAssignedProjects(idEmployee, endDate);
    }
  },
  {
    type: 'taskByEmployeeAndProject',
    useHook: ({ idEmployee, idProject }) => {
      return useTaskByEmployeeAndProject(idEmployee, idProject);
    }
  }
];

// Mapping of query types to their respective hooks
const queryHookMap = queries.reduce((acc, query) => {
  acc[query.type] = query.useHook;
  return acc;
}, {} as Record<QueryType, QueryHook['useHook']>);

// Generic hook to use queries based on their type
export function useQuery<T>(
  queryType: QueryType,
  queryParams?: unknown
): QueryHookResult<T> | null {
  const hookFn = queryHookMap[queryType];
  
  if (hookFn) {
    return hookFn(queryParams) as QueryHookResult<T>;
  }

  // If no hook is found for the given type, return null
  console.warn(`No query hook found for type: ${queryType}`);
  return null;
}
